import { Module } from 'vuex';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { serializer } from '../../api/shared/serializer';
import { getRegionName } from '@/utils/functionsRegion';

const contentLibraryModule: Module<any, any> = {
  namespaced: false,
  state: {
    contentCategories: [],
    contentItems: [],
    contentItem: null,
  },

  mutations: {
    setContentItems(state: any, payload: []) {
      state.contentItems = payload;
    },

    setContentItem(state: any, payload: null) {
      state.contentItem = payload;
    },

    setContentCategories(state: any, payload: null) {
      state.contentCategories = payload;
    },
  },

  actions: {
    async getContentCategories({ commit }) {
      const items = firebase
        .firestore()
        .collection('contentCategories')
        .where('facilityId', '==', this.state.authModule.currentFacility);

      return await items.get().then(querySnapshot => {
        commit('setContentCategories', serializer.querySnapshotToDocuments<any>(querySnapshot));
      });
    },

    async getContentItems({ commit }) {
      const items = await firebase
        .firestore()
        .collection('contentLibrary')
        .where('facilityId', '==', this.state.authModule.currentFacility).get()
        .then((querySnapshot: any) => {
          let items = serializer.querySnapshotToDocuments<any>(querySnapshot)
          items = items.map(x=>({categoryNames: (x.categories? x.categories.map(x=>x.name).join(", "):[]) ,...x}))
          commit('setContentItems', items);
        });
    },

    async getContentItemById({ commit }, id) {
      const contentItem = firebase
        .firestore()
        .collection('contentLibrary')
        .doc(id);

      await contentItem.get().then(querySnapshot => {
        commit(
          'setContentItem',
          serializer.documentSnapshotToDocument<any>(querySnapshot)
        );
      });
    },

    async getContentCategoryByFacility({ commit }, data) {
      const query = firebase
        .firestore()
        .collection('contentCategories')
        .where('facilityId', '==', data.facilityId)
        .where('name', '==', data.name);

      return await query.get().then(querySnapshot => {
        if (querySnapshot.docs.length) {
          return serializer.documentSnapshotToDocument<any>(querySnapshot.docs[0])
        }
        else {
          return querySnapshot.docs[0]
        }
      });
    },


    async addContentCategories({ dispatch }, categories: any[]) {
      if (!categories || !categories.length) return;

      const db = firebase.firestore();
      const batch = db.batch();
      for (let i = 0; i < categories.length; i++) {
        const docRef = db.collection('contentCategories').doc();

        const category = {
          ...categories[i],
          isEnabled: true,
          dateTimeCreated: firebase.firestore.Timestamp.fromDate(new Date()),
          createdByStaffId: this.state.authModule.user.id,
          createdByStaffName: this.state.authModule.user.name,
          facilityId: this.state.authModule.currentFacility,
        };

        batch.set(docRef, category);
      }

      const result = await batch.commit()

      return result;
    },

    async addContentCategory({ commit }, category: any) {
      if (!category) return;

      category.dateTimeCreated = firebase.firestore.Timestamp.fromDate(new Date())
      category.createdByStaffId = this.state.authModule.user.id
      category.createdByStaffName = this.state.authModule.user.name

      if (!category.facilityId) {
        category.facilityId = this.state.authModule.currentFacility
      }

      const response = await firebase.app().functions(getRegionName()).httpsCallable('utils-addOrgDocument')({
        orgId: this.state.authModule.currentFacilityData.orgId,
        collectionName: 'contentCategories',
        document: category
      });

      return response.data
    },

    async addContent({ commit }, content: any) {
      if (!content) return;

      if (!content.facilityId) {
        content.facilityId = this.state.authModule.currentFacility;
      }
      content.createdByStaffId = this.state.authModule.user.id;
      content.createdByStaffName = this.state.authModule.user.name;
      content.dateTimeCreated = firebase.firestore.Timestamp.fromDate(new Date());

     const response = await firebase.app().functions(getRegionName()).httpsCallable('utils-addOrgDocument')({
        orgId: this.state.authModule.currentFacilityData.orgId,
        collectionName: 'contentLibrary',
        document: content
      });

      return response.data
    },

    async deleteContent({ commit }, media: any) {

      if (!media || !media.id) return

      const snap = await firebase.firestore().collection("contentLibrary").doc(media.id).get()

      if(snap.exists){
        //folder with files are removing on the trigger side
        return await snap.ref.delete().then(() => {
          console.log('media deleted')
        })
      }

      return
    },

    async updateContentCategories({ commit }, categories: any[]) {
      if (!categories || !categories.length) return;

      const db = firebase.firestore();
      const batch = db.batch();
      categories.forEach(doc => {
        const docRef = firebase
          .firestore()
          .collection('contentCategories')
          .doc(doc.id);
        const name = categories.find(x => x.id == doc.id).name;
        batch.update(docRef, { name: name });

        db.collection('contentLibrary')
          .where('facilityId', '==', this.state.authModule.currentFacility)
          .where('categoryIds', 'array-contains', doc.id)
          .get()
          .then((querySnapshot) => {
            querySnapshot.docs.forEach((item) => {
              const media = item.data()
              const categories = media.categories.filter(x => x.id !== doc.id);
              const editCategory = media.categories.filter(x => x.id === doc.id)[0];
              editCategory.name = doc.name;
              db.collection('contentLibrary')
                .doc(item.id)
                .update({'categories': [editCategory, ...categories]});
            })
          });

      });
      return await batch.commit();
    },

    async deleteContentCategories({ commit }, categories: any[]) {
      if (!categories || !categories.length) return;
      
      const db = firebase.firestore();
      const batch = db.batch();
      categories.forEach(function (doc) {
        if(doc.id){
          const docRef = firebase.firestore().collection('contentCategories').doc(doc.id);
          batch.delete(docRef);
        }
      });
      const result = await batch.commit();
      return result
    }
  }
};
export default contentLibraryModule;
